import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult } from '../../../shared/model/Index';
import { INote, INoteSearchParam } from '../model/note';
import { environment as env } from '@environments/environment'
import { Guid } from 'guid-typescript';

@Injectable({ providedIn: 'root' })

export class NoteService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    search(noteSearch:INoteSearchParam) {
        return this.http.post<ApiResult<INote[]>>(env.apiUrl + 'Note/NoteSearch', noteSearch);
    }
    post(note: INote) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'Note', note);
    }
    put(note: INote) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'Note', note);
    }
    delete(id:Guid) {
        return this.http.delete<ApiResult<number>>(env.apiUrl + 'Note/' + id);
    }
}